import { ResizeTask } from './ResizeTask';
import { ResizeEvent } from './ResizeEvent';
import { ResizeGateway } from './ResizeGateway';

export const ResizeModule = {
    __init__: ['resizeTask', 'resizeEvent', 'resizeGateway'],
    resizeTask: ['type', ResizeTask],
    resizeEvent: ['type', ResizeEvent],
    resizeGateway: ['type', ResizeGateway],
};
